import { useState } from 'react';
import { Box, Button, Flex, Heading, IconButton } from '@chakra-ui/react';
import { RiAddFill, RiFilter2Line } from 'react-icons/ri';
import { useAuthContext } from '@contexts/auth';
import PaginationRouterContainer from '@components/PaginationRouterContainer';
import Loading from '@components/Loading';

import TeamCard from './components/TeamCard';
import AddDialog from './components/AddDialog';
import useGetList from './hooks/useGetList';
import Filters from './components/Filters';
import SelectedFiltersList from './components/SelectedFiltersList';

const Teams = () => {
  const [showAddDialog, setShowAddDialog] = useState(false);
  const [showFilters, setShowFilters] = useState(false);

  const { checkIfHasRole } = useAuthContext();

  const {
    getTeams,
    teams,
    totalPages,
    loading,
  } = useGetList();

  const getCurrentComponent = () => {
    if (loading && teams.length === 0) return <Loading />;

    if (!loading && teams.length === 0) {
      return (
        <Box textAlign="center" mt={20} color="gray.500">
          Nenhuma equipe encontrada.
        </Box>
      );
    }

    return (
      <Box opacity={loading ? 0.5 : 1} transition="opacity 0.15s ease">
        <PaginationRouterContainer
          total={totalPages}
        >
          {teams.map((team) => (
            <TeamCard
              key={team.id}
              team={team}
              refetch={() => getTeams({})}
            />
          ))}
        </PaginationRouterContainer>
      </Box>
    );
  }

  return (
    <Box>
      <Flex justifyContent="space-between" alignItems="flex-end" mb={2}>
        <Flex alignItems="center">
          <Heading>Equipes</Heading>
          <IconButton
            variant="ghost"
            color="argos.fg"
            onClick={() => setShowFilters((prev) => !prev)}
          >
            <RiFilter2Line size={24} />
          </IconButton>
        </Flex>
        {checkIfHasRole('CAN_CREATE_TEAMS') && (
          <Button size="sm" onClick={() => setShowAddDialog(true)}>
            <RiAddFill /> Novo
          </Button>
        )}
      </Flex>

      {showFilters ? (
        <Filters onClose={() => setShowFilters(false)} />
      ) : (
        <SelectedFiltersList />
      )}

      {getCurrentComponent()}

      {showAddDialog && (
        <AddDialog
          handleClose={() => setShowAddDialog(false)}
          afterSubmit={() => getTeams({})}
        />
      )}
    </Box>
  );
};

export default Teams;
